import {
  CustomSelect,
  SingleItemSelectedDefault,
} from '@/components/inputs/CustomSelect'
import { useCustomSelectStateFromInfiniteScrollProvider } from '@/components/inputs/infinite-scroll-provider-hook'
import { observer } from 'mobx-react-lite'
import { SearchResultItem } from '@/components/inputs/SearchResultItem'
import { FormRow } from '@/components/Form'
import { FormGroupContainer } from '@/components/FormContainer'
import { type WorkspaceSelection } from '@/features/inventory/admin/WorkspaceSelectorViewModel'
import { Avatar } from '@/components/Avatar'

export interface InventoryItemFormWorkspaceDropdownContainerProps {
  vm: WorkspaceSelection
}

export const InventoryItemFormWorkspaceDropdownContainer = observer(
  function InventoryItemFormWorkspaceDropdownContainer({
    vm,
  }: InventoryItemFormWorkspaceDropdownContainerProps) {
    const testId = 'inventory-item-modal'
    const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
      scrollProvider: vm.workspaceSelectorVm.scrollProvider,
      searchText: vm.workspaceSelectorVm.searchText,
      onSearchTextChange: vm.workspaceSelectorVm.setSearchText,
      searchResults: vm.workspaceSelectorVm.filteredWorkspaces,
    })

    return (
      <FormRow>
        <FormGroupContainer
          label="Select workspace"
          error={vm.workspaceValidation.getError('workspace')}
        >
          <CustomSelect
            {...selectProps}
            placeholder="Select workspace"
            testId={`${testId}-workspace-dropdown`}
            itemToString={(v) => String(v?.name)}
            value={vm.workspace}
            multi={false}
            onChange={vm.setWorkspace}
            renderItem={(itemProps) => (
              <SingleItemSelectedDefault
                {...itemProps}
                visual={
                  <Avatar
                    size={24}
                    subject={{
                      displayName: itemProps.item.name,
                      avatar: itemProps.item.branding.logos.icon,
                    }}
                  />
                }
              />
            )}
            renderSearchItem={({
              item,
              itemToString: _itemToString,
              ...itemProps
            }) => (
              <SearchResultItem
                {...itemProps}
                data-test={`${testId}-workspace-${item.name}`}
                visual={
                  <Avatar
                    size={24}
                    subject={{
                      avatar: item.branding.logos.icon,
                      displayName: item.name,
                    }}
                  />
                }
              >
                {item.name}
              </SearchResultItem>
            )}
          />
        </FormGroupContainer>
      </FormRow>
    )
  },
)
